import React from "react";
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Tooltip,
} from "antd";
import TextArea from "antd/lib/input/TextArea";
import { portfolio } from "../../../../../utils/NewPropertyHelper";
import { salutations } from "../../../../../utils/Util";
import { FaQuestionCircle } from "react-icons/fa";
import { DynamicPhone } from "../../../../../components/DynamicPhone"; 

function PropertyInformation({ propertyType }) {
  return (
    <>
      {propertyType === "Single Family" && (
        <>
          <Form.Item label="Status" name="status">
            <p>Vacant</p>
          </Form.Item>
          <Form.Item
            label="Rent Ready"
            name="rentReady"
            valuePropName="checked"
            initialValue={false}
          >
            <Checkbox></Checkbox>
          </Form.Item>
          <Form.Item name="showingOn" label="Ready For Showing On">
            <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
          </Form.Item>
        </>
      )}
      <Form.Item label="Description" name="description">
        <TextArea rows={4} />
      </Form.Item>
      <Form.Item
        label={
          <span className="plain-text">
            Portfolio{" "}
            <Tooltip title="tooltip text">
              <FaQuestionCircle size={12} className="circled-question" />{" "}
            </Tooltip>
          </span>
        }
        name="portfolio"
      >
        <Select options={portfolio} />
      </Form.Item>
      <Form.Item label="Site Manager">
        <Row>
          <Col flex={2}>
            <Form.Item name="managerSalutation">
              <Select options={salutations} />
            </Form.Item>
          </Col>
          <Col flex={1}></Col>
          <Col flex={4}>
            <Form.Item name="managerFirstName">
              <Input placeholder="First name" />
            </Form.Item>
          </Col>
          <Col flex={1}></Col>
          <Col flex={4}>
            <Form.Item name="managerLastName">
              <Input placeholder="Last Name" />
            </Form.Item>
          </Col>
        </Row>
      </Form.Item>
      <Form.Item label="Phone Number" name="managerPhoneNumber">
        <DynamicPhone />
      </Form.Item>
      <Form.Item label="Year Built" name="yearBuilt">
        <Input placeholder="" />
      </Form.Item>
      <Form.Item name="managementStartDate" label="Managment Start Date">
        <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
      </Form.Item>
      {propertyType === "Single Family" ? (
        <>
          <Form.Item
            label="Liability to Landlord Insurance"
            name="liabilitytoLandlordInsurance"
          >
            <Select options={[{ value: "On" }, { value: "Off" }]} />
          </Form.Item>
          <Form.Item
            label="FolioGuard Policy Additional Interest"
            name="policyAdditionalInterest"
            valuePropName="checked"
            initialValue={true}
          >
            <Checkbox disabled></Checkbox>
          </Form.Item>
          <Form.Item label="Interested Party" name="interestedParty">
            <Input placeholder="Integrity Oklahoma LLC" disabled />
          </Form.Item>
          <Form.Item label="Contact Email" name="contactEmail">
            <Select options={[{ value: "eaglesayeagle@gmail.com" }, { value: "dev.sayeagle@gmail.com" }]} />
          </Form.Item>
        </>
      ) : null}
      {/* <span>
        <h4>Tags</h4>
      </span>
      <Form.Item label="" name="tags" >
        <Select mode="tags" tokenSeparators={[]} options={salutations} />
      </Form.Item> */}
      {/* <Button type="link" style={{ padding: "0px" }}>
        Manage Tags
      </Button> */}
    </>
  );
}

export default PropertyInformation;
